module.exports = __webpack_public_path__ + "img/clip.24e90bdb.svg";